import BarChartIcon from '@mui/icons-material/BarChart';
import { styled } from '@mui/material/styles';

export { default as Bank } from '@mui/icons-material/AccountBalance';
export { default as Debit } from '@mui/icons-material/ArrowDownward';
export { default as Credit } from '@mui/icons-material/ArrowUpward';
export { default as Assistant } from '@mui/icons-material/AutoAwesome';
export { default as Chart } from '@mui/icons-material/BarChart';
export { default as Accounting } from '@mui/icons-material/Calculate';
export { default as Close } from '@mui/icons-material/Close';
export { default as Copy } from '@mui/icons-material/ContentCopy';
export { default as Delete } from '@mui/icons-material/DeleteOutlined';
export { default as Euro } from '@mui/icons-material/EuroSymbol';
export { default as Filter } from '@mui/icons-material/FilterList';
export { default as TransferArrow } from '@mui/icons-material/KeyboardArrowRight';
export { default as Category } from '@mui/icons-material/Label';
export { default as SignIn } from '@mui/icons-material/Login';
export { default as Login } from '@mui/icons-material/Login';
export { default as Logout } from '@mui/icons-material/Logout';
export { default as Menu } from '@mui/icons-material/Menu';
export { default as Edit } from '@mui/icons-material/ModeEditOutlined';
export { default as Transfer } from '@mui/icons-material/MoveDown';
export { default as Cash } from '@mui/icons-material/Payments';
export { default as PieChart } from '@mui/icons-material/PieChart';
export { default as Savings } from '@mui/icons-material/Savings';
export { default as SearchOff } from '@mui/icons-material/SearchOff';
export { default as Investment } from '@mui/icons-material/ShowChart';
export { default as Transaction } from '@mui/icons-material/SyncAlt';
export { default as Account } from '@mui/icons-material/Wallet';

export const HorizontalChart = styled(BarChartIcon)({
  transform: 'rotate(90deg)',
});
